import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2e3cc3d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "stats-container" }
const _hoisted_4 = { class: "stats-element" }
const _hoisted_5 = {
  key: 1,
  class: "value"
}
const _hoisted_6 = { class: "value-name" }
const _hoisted_7 = { class: "header" }
const _hoisted_8 = { class: "stats-container" }
const _hoisted_9 = { class: "stats-element" }
const _hoisted_10 = { class: "value-name" }
const _hoisted_11 = { class: "stats-element" }
const _hoisted_12 = { class: "value-name" }
const _hoisted_13 = { class: "header" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "#", -1))
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  key: 0,
  class: "status-circle status-circle-green item-center"
}
const _hoisted_20 = {
  key: 1,
  class: "status-circle status-circle-yellow item-center"
}

import {onMounted, Ref, ref} from "vue";
import config from "@/config.json";
import {Stats} from "@/types/Stats";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatsView',
  setup(__props) {

const values = ['guilds', 'users', 'channels', 'emojis'];
let statistics: Ref<Stats> = ref({} as Stats);
let shards: Ref<Record<string, any>> = ref([]);

onMounted(async () => {
  let response = await fetch(config.API + '/public/stats');
  statistics.value = await response.json();
  shards.value = statistics.value.shards.map(shard => {return {
    id: shard.id,
    ready: shard.ready,
    guilds: shard.guilds,
    users: shard.users,
    ping: shard.ping + ' ms'
  }})
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Stats.name')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(values, (value) => {
        return _createElementVNode("div", _hoisted_4, [
          (!_unref(statistics).shards?.length)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 0,
                size: 45,
                width: "4",
                indeterminate: ""
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(statistics).stats[value]), 1)),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(`Stats.${value}`)), 1)
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('Stats.ping')), 1),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (!_unref(statistics).shards?.length)
          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 0,
              size: 45,
              width: "4",
              indeterminate: ""
            }))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "value",
              style: _normalizeStyle({color: _unref(statistics).ping.bot < 300 ?
        '#00f56e' : (_unref(statistics).ping.bot > 1000 ? '#e20000' : '#ffd70c')})
            }, _toDisplayString(_unref(statistics).ping.bot) + " " + _toDisplayString(_ctx.$t('Stats.ms')), 5)),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('Stats.bot')), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (!_unref(statistics).shards?.length)
          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 0,
              size: 45,
              width: "4",
              indeterminate: ""
            }))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "value",
              style: _normalizeStyle({color: _unref(statistics).ping.database < 300 ?
        '#00f56e' : (_unref(statistics).ping.database > 1000 ? '#e20000' : '#ffd70c')})
            }, _toDisplayString(_unref(statistics).ping.database) + " " + _toDisplayString(_ctx.$t('Stats.ms')), 5)),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('Stats.database')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('Stats.shards')), 1),
    _createVNode(_component_v_table, { class: "shards-table item-center" }, {
      default: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_14,
            _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('Stats.status')), 1),
            _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('Stats.guilds')), 1),
            _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('Stats.users')), 1),
            _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('Stats.ping')), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statistics).shards, (shard) => {
            return (_openBlock(), _createElementBlock("tr", null, [
              _createElementVNode("td", null, _toDisplayString(shard.id), 1),
              _createElementVNode("td", null, [
                (shard.ready)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20))
              ]),
              _createElementVNode("td", null, _toDisplayString(shard.guilds), 1),
              _createElementVNode("td", null, _toDisplayString(shard.users), 1),
              _createElementVNode("td", null, _toDisplayString(shard.ping) + " " + _toDisplayString(_ctx.$t('Stats.ms')), 1)
            ]))
          }), 256))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})